export default __webpack_public_path__ + "static/fractal-a00303b95b9448546bd3b1fac39ca8db.gif";